import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickPaymentsState } from '../../selectors/one-click-payments.selector';

export class OneClickPaymentDisabler extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickPaymentsState).pipe(
      filter(state => !!state),
      map(state => state.loading[this.mapItem['index']]),
    );
  }
}
